import { IUpdatePatrimonioMaquinaEquipUseCase } from "../../../presentation/useCases/update/update_patrimonio_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";
/**
 * UpdatePatrimonioMaquinaEquipUseCase
 */

export class UpdatePatrimonioMaquinaEquipUseCase implements IUpdatePatrimonioMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updatePatrimonioMaquinaEquip(
    idPatrimonioMaquinaEquip: number,
    idPatrimonioCentroCusto?: number | null,
    idChecklistMaquinaEquip?: number | null,
    descricao?: string | null,
    status?: number | null,
  ): Promise<void> {
    await this.repository.updatePatrimonioMaquinaEquip(
      idPatrimonioMaquinaEquip,
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      descricao,
      status,
    );
  }
}
